import { ApplicationElement, html } from '@beunity/lit-components';

/**
 * A simple generic list item featuring three placeholders.
 * The whole item behaves as a link.
 *
 * @prop label - Featured text, e.g. date, role etc.
 * @prop text - The main content, e.g. Title, Name
 * @prop hint - Optional text
 * @prop href - URL
 */
export default class ListItem1 extends ApplicationElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    label: { type: String },
    text: { type: String },
    hint: { type: String },
    href: { type: String },
  };

  renderHint() {
    return html` <span class="type">${this.hint}</span> `;
  }

  renderContent() {
    return html`
      <span class="event-date">${this.label}</span>
      <h3 class="title">${this.text} ${this.hint && this.renderHint()}</h3>
    `;
  }

  render() {
    return html`
      <a href="${this.href}" class="content"> ${this.renderContent()} </a>
    `;
  }
}

customElements.get('bu-list-item-1') ||
  customElements.define('bu-list-item-1', ListItem1);
